import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// Same-origin path — nginx proxies this to https://firefly-api.adobe.io,
// sidestepping the CORS block a direct browser call would hit. See the
// /firefly-api-status/ location block in nginx.development.conf.template /
// nginx.production.conf.template.
const FIREFLY_GENERATE_PATH = '/firefly-api-status/v3/images/generate';

@Component({
  selector: 'app-adobe-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './adobe-status.component.html',
  styleUrls: ['./adobe-status.component.scss']
})
export class AdobeStatusComponent {
  isLoading = false;
  responseStatus: number | null = null;
  responseBody = '';

  constructor(private http: HttpClient) { }

  checkStatus(): void {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.responseStatus = null;
    this.responseBody = '';

    this.http.post(
      FIREFLY_GENERATE_PATH,
      { prompt: 'A test prompt for connectivity check' },
      { observe: 'response', responseType: 'text' }
    ).subscribe({
      next: (response) => {
        this.responseStatus = response.status;
        this.responseBody = response.body || '';
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.responseStatus = error.status;
        this.responseBody = typeof error.error === 'string'
          ? error.error
          : JSON.stringify(error.error ?? error.message);
        this.isLoading = false;
      }
    });
  }
}
